import { render, staticRenderFns } from "./range-year2.vue?vue&type=template&id=64a53024&"
import script from "./range-year2.vue?vue&type=script&lang=js&"
export * from "./range-year2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider2: require('/var/www/components/range/range-slider2.vue').default})
